function moduleNewsroom(){
    //Make featured post sticky
    $(window).on('scroll resize', function() {
		//Set max width on featured post
		$('.m__newsroom .m__newsroom-featured-post').css('max-width', $('.m__newsroom .featured-col').width());    	
        stickySection();
    });	

	var masonryOptions = {
		columnWidth: '.grid-sizer',
		gutter: '.gutter-sizer',
		itemSelector: '.grid-item',
		percentPosition: true
	};

	var $grid = $('.grid').masonry( masonryOptions );	

	$('.js__newsroom-filter').on('change', function(e) {
		var grid = $('.m__newsroom .m__newsroom-posts');
		var gridItem = $('.m__newsroom .m__newsroom-posts .m__newsroom-posts-item');
		var filter = $(this).find(':selected').val();

		console.log(filter);

		gridItem.addClass('hiding');

		 $.ajax({
	        url: '/wp-content/themes/rhubarb-duplo/library/php/newsroomFilterPosts.php',
	        type: 'POST',
	        dataType:'html',
			data: {
				'setFilter' : filter
			},
	        success: function (data) {
	        	gridItem.remove(); //Remove all currently displayed posts!
	        	$grid.masonry('destroy');
	        	grid.append(data); //Add the new posts in!
	        	$grid.masonry( masonryOptions );
	        	$('.m__newsroom .m__newsroom-posts .m__newsroom-posts-item').removeClass('hiding');
	        },
	        error: function(xhr, textStatus, errorThrown){
	        	alert('Sorry an error occured. Please check your internet connection.');
		    }
	    });		
	});
}

function stickySection() {
	if ( $('.m__newsroom').length ) {
	    var windowTop = $(window).scrollTop();
	    var windowBottom = windowTop + $(window).height();
	    var offset = $('.header').outerHeight() + 40;
	    var elementTop = $('.m__newsroom').offset().top - offset;
	    var elementBottom = $('.m__newsroom').offset().top + ($('.m__newsroom').outerHeight() + 40);

	    if ( windowTop > elementTop && windowBottom <= elementBottom ) { // Section is in view
	    	$('.m__newsroom-featured-post').addClass('stick');
	    	$('.m__newsroom-featured-post').removeClass('end');
	    } else {
	    	$('.m__newsroom-featured-post').removeClass('stick');

	    	if ( windowBottom > elementBottom ) {
	    		$('.m__newsroom-featured-post').addClass('end');
	    	}
	    }
	}
}